<template>
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h5 class="mb-0">NÚMERO DE ORDEN</h5>
    </div>
    <div class="card-body">
      <div class="form-group">
        <label for="order_number">NÚMERO DE ORDEN</label>
        <input
          :value="localResume.order_number"
          @input="$emit('update:field', 'order_number', $event.target.value)"
          type="text"
          class="form-control"
          id="order_number"
          placeholder="Número de orden del registro"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderNumberSection",
  props: {
    localResume: {
      type: Object,
      required: true,
    },
  },
};
</script>
